"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugin_1 = __importDefault(require("tailwindcss/plugin"));
const utils_1 = require("./utils");
const types_1 = require("./types");
const applySchema = (schema = {}) => {
    const reducedSchema = (0, utils_1.reduceSchema)(schema);
    return (Object.entries(reducedSchema)
        .reduce((obj, [key, value]) => (Object.assign(Object.assign({}, obj), { [`--${(0, utils_1.camel2KebabCase)(key)}`]: (0, utils_1.getExistProperty)(reducedSchema, value) })), {}));
};
function withOpacityValue(variable, withOpacity) {
    return ({ opacityValue }) => {
        if (!withOpacity)
            return `var(${variable})`;
        if (opacityValue === undefined) {
            return `rgb(var(${variable}))`;
        }
        return `rgb(var(${variable}) / ${opacityValue})`;
    };
}
const setSchema = (schema, group, withOpacity = false) => (Object.keys(schema[group]).reduce((obj, key) => (Object.assign(Object.assign({}, obj), { [key]: withOpacityValue(`--${(0, utils_1.getPrefix)(group)}${(0, utils_1.camel2KebabCase)(`${key}`)}`, withOpacity) })), {}));
exports.default = plugin_1.default.withOptions((schemas) => ({ addComponents }) => {
    const defaultSchema = (0, types_1.isColorsSchemas)(schemas)
        ? schemas.defaultSchema : schemas;
    const root = {
        ':root': applySchema(defaultSchema),
        ':root[mode=dark]': (0, types_1.isColorsSchemas)(schemas) && schemas.dark ? applySchema(schemas.dark) : '',
    };
    addComponents(root);
}, (schemas) => {
    const defaultSchema = (0, types_1.isColorsSchemas)(schemas)
        ? schemas.defaultSchema : schemas;
    return ({
        theme: {
            extend: {
                colors: setSchema(defaultSchema, 'colors', true),
                fontWeight: setSchema(defaultSchema, 'fontWeight'),
                boxShadow: setSchema(defaultSchema, 'boxShadow'),
                borderWidth: setSchema(defaultSchema, 'borderWidth'),
                borderRadius: setSchema(defaultSchema, 'borderRadius'),
            },
        },
    });
});
//# sourceMappingURL=tailwind.js.map